import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/components';
import { LoaderService } from './shared/services';
import { AsyncPipe, NgClass } from '@angular/common';
import { BrandService } from '@app/shared/services/brand/brand.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent, AsyncPipe, NgClass],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Rutt-Angular';

  // -- INYECCIÓN DE SERVICIOS --
  public loader = inject(LoaderService);
  private brandService = inject(BrandService);

  // -- VARIABLES DE ESTADO --
  public isDevEnvironment = false;
  public isPervolareMode = false;

  ngOnInit(): void {
    this.brandService.initTheme();

    const hostname = window.location.hostname;
    this.isDevEnvironment =
      hostname === 'localhost' || hostname === 'dev-rutt.pervolare.net';

    const savedDomain = localStorage.getItem('dev_simulated_domain');
    this.isPervolareMode = savedDomain === 'solicitudreembolsos.pervolare.com';
  }

  toggleDominioPrueba(event: Event): void {
    this.isPervolareMode = (event.target as HTMLInputElement).checked;
    const dominioSimulado = this.isPervolareMode
      ? 'solicitudreembolsos.pervolare.com'
      : 'tas-rutt.pervolare.net';

    this.brandService.initTheme(dominioSimulado);
  }
}
